import React from 'react'
import header from './HeaderContact.module.scss'
import HeaderButton from '../../components/HeaderButton/HeaderButton'

const HeaderContact = ({isOpen}) => {

    return (
        <div className={header.contacts}>
            <HeaderButton/>
            <div className={header.box_phone}>
                <a className={header.phone}  href="tel:+79101740505" target='_blank' rel='noopener noreferrer'>+7 (910) 174-05-05</a>
            </div>
        </div>
    );
};

export default HeaderContact